module.exports = __webpack_public_path__ + "ba9cab64c28f43818b91ce10582081b7.png";